import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { ApiTypes } from 'common';
import { ApiError } from '@src/services/api';
import { getInfluencersCreators, getBlacklistedCreators } from './api';
import { useAuthEnabled } from '@src/hooks/useAuthStatus';

/**
 * Get influencers
 */

export const useQueryInfluencersCreators = () =>
  {
    const authEnabled = useAuthEnabled();

    return useQuery<ApiTypes.ResGetCreatorsList, ApiError | Error>({
      queryKey: QUERY_KEYS.influencers(),
      queryFn: getInfluencersCreators,
      enabled: authEnabled,
    });
  };

export const useQueryBlacklistedCreators = () =>
  {
    const authEnabled = useAuthEnabled();

    return useQuery<ApiTypes.ResGetCreatorsList, ApiError | Error>({
      queryKey: QUERY_KEYS.blacklistedCreators(),
      queryFn: getBlacklistedCreators,
      enabled: authEnabled,
    });
  };

